import { MAX_ENTITY_REF_IDS } from '@orn/global/assistant/inlineMarkup.js';

import type { IConversationMessage } from '../../hooks/useAssistantWebSocket';

/**
 * The alerts a transcript's cards name, deduped and in a stable order.
 *
 * Deduped because a transcript holds one card per expand, not per alert:
 * re-clicking an alert row deliberately re-inserts it, so live transcripts and
 * rehydrated history alike can carry several cards for the same alert. The
 * dedupe is what keeps the work-item read's query variables one-per-alert and
 * the {@link MAX_ENTITY_REF_IDS} cap counting alerts rather than clicks.
 * Sorted so a re-render that reorders nothing produces identical query
 * variables and hits the Apollo cache instead of refetching.
 *
 * Capped at {@link MAX_ENTITY_REF_IDS}, which is the page size the read clamps
 * to: asking for more returns one page anyway, so the excess is dropped here
 * where it is visible rather than silently truncated server-side. A transcript
 * with that many distinct cards is far past any real session.
 */
export function collectAlertCardIds(messages: readonly IConversationMessage[]): string[] {
  const ids = new Set<string>();
  for (const message of messages) {
    if (message.kind === 'alert-card' && message.alertId !== undefined) {
      ids.add(message.alertId);
    }
  }
  return [...ids].toSorted().slice(0, MAX_ENTITY_REF_IDS);
}
